/**
 * Detects if the current browser is an in-app browser (Facebook, Instagram, etc.)
 * @returns {string|false} The name of the in-app browser, or false if not detected
 */
export const detectInAppBrowser = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const ua = navigator.userAgent || navigator.vendor || window.opera;

  // Check for test override in localStorage first (for Cucumber tests)
  // Guard against localStorage being undefined (React Native environment)
  const testOverride = typeof localStorage !== 'undefined' ? localStorage.getItem('simulatedInAppBrowser') : null;
  if (testOverride) {
    return testOverride;
  }

  // Zalo
  if (ua.indexOf('Zalo') > -1) return 'Zalo';

  // Instagram
  if (ua.indexOf('Instagram') > -1) return 'Instagram';

  // Facebook Messenger (check FBOP/80 first, then fallback to FBAN patterns)
  if (ua.indexOf('FBOP/80') > -1) return 'Messenger';
  if (ua.indexOf('FBAN/MessengerForiOS') > -1 || ua.indexOf('FBAN/MessengerLite') > -1 || ua.indexOf('FBAN/Messenger') > -1) return 'Messenger';

  // Facebook app (FBOP/5 or generic FBAN/FBAV)
  if (ua.indexOf('FBOP/5') > -1) return 'Facebook';
  if (ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1) return 'Facebook';

  // Twitter
  if (ua.indexOf('Twitter') > -1) return 'Twitter';

  // LinkedIn
  if (ua.indexOf('LinkedInApp') > -1) return 'LinkedIn';

  // TikTok
  if (ua.indexOf('BytedanceWebview') > -1 || ua.indexOf('TikTok') > -1) return 'TikTok';

  // WeChat
  if (ua.indexOf('MicroMessenger') > -1) return 'WeChat';

  // Line
  if (ua.indexOf('Line') > -1) return 'Line';

  return false;
};

/**
 * Opens the current URL in an external browser
 * Uses platform-specific methods or falls back to window.openExternalBrowser if available
 * @param {string} url - Optional URL to open. Defaults to current location.
 */
export const openInExternalBrowser = (url = window.location.href) => {
  // Use the openExternalBrowser function if available (set up by external library or test)
  if (typeof window.openExternalBrowser === 'function') {
    window.openExternalBrowser(url);
    return;
  }

  // Fallback: try to open in external browser using platform-specific methods
  const isAndroid = /Android/.test(navigator.userAgent);
  if (isAndroid) {
    const intentUrl = `intent://${url.replace(/https?:\/\//, '')}#Intent;scheme=https;action=android.intent.action.VIEW;end`;
    window.location.href = intentUrl;
  } else {
    // iOS: Use x-safari- URL scheme
    const safariUrl = 'x-safari-' + url;
    window.location.href = safariUrl;
  }
};
